import { render, staticRenderFns } from "./collection-manage.vue?vue&type=template&id=28018a0b"
import script from "./collection-manage.vue?vue&type=script&lang=ts"
export * from "./collection-manage.vue?vue&type=script&lang=ts"
import style0 from "./collection-manage.vue?vue&type=style&index=0&id=28018a0b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports